<template>
  <div class="">
    <navbar></navbar>
    <main class="main" role="main">
      <div class="py-5 bg-light">
        <div class="container">
          <div class="col-md-12 p-0">
            <router-link to="top">{{$t('ordertop.myhome')}}</router-link> / <router-link to="order">{{$t('top.myorder')}}</router-link> / {{$t('OrderCreate.OrderCreate')}}
            <div class="mt-4 col-12 col-sm-9 col-md-7 col-lg-6 pl-0 pr-0">
              <ul class="nav nav-tabs wizard pl-0 pr-0">
                <li :class="{active:step===1,completed:step>1}"><a>{{$t('OrderCreate.Terms')}}</a></li>
                <li :class="{active:step===2,completed:step>2}"><a>{{$t('OrderCreate.Input')}}</a></li>
                <li :class="{active:step===3,completed:step>3}"><a>{{$t('OrderCreate.Confrim')}}</a></li>
                <li :class="{active:step>=4}"><a>{{$t('OrderCreate.Complete')}}</a></li>
              </ul>
            </div>
            <div v-if="step===1">
              <div class="card mt-4">
                <div class="card-body pb-2 pr-0">
                  <h4 class="text-center">
                    {{$t('OrderTerms.TermsTitle')}}
                  </h4>
                  <div class="privacyPolicy-scroll-bar">
                    <div class="pt-4 col-10 offset-1 p-0">
                      <div class="" v-html="$t('privacyPolicy.registerPrivacyPolicy')"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="input-group mt-4">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <input id="confirm" type="checkbox" @click="confirmed=!confirmed" aria-label="Checkbox for following text input" :checked="confirmed">
                  </div>
                </div>
                <label type="text" class="form-control" style="width: auto;flex: none;" aria-label="Text input with checkbox" for="confirm">{{$t('OrderTerms.confirmed')}}</label>
              </div>
            </div>
            <div v-if="step===2||step==3">
              <div class="card mt-4">
                <div class="card-body">
                  <div class="">
                    <span>{{$t('OrderCreate.text')}} </span>
                  </div>
                </div>
              </div>
              <div class="card mt-4 pt-3 pb-3">
                <div class="card-body">
                  <nav class="navbar navbar-light col-12 ">
                    <div class="col-12 col-lg-4">
                      <label for="amountOfCurrency" class="navbar-brand">{{$t('OrderCurrency.amountOfCurrency')}}</label>
                      <a tabindex="0" class="btn btn-sm border-0" role="button" data-toggle="popover" data-trigger="focus" :title="$t('OrderCurrency.amountOfCurrency')" :data-content="$t('OrderCurrency.amountOfCurrencyTips')"><img src="../../../static/img/info.svg"></a>
                    </div>
                    <div class="form-inline col-12 col-lg-8 p-0">
                      <div class="input-group col-12">
                        <div class="input-group-prepend">
                          <div class="dropdown show">
                            <a class="btn btn-secondary dropdown-toggle" style="border-top-right-radius:0em;border-bottom-right-radius:0em;" :class="{disabled:step==3}" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              {{currency}}
                            </a>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                              <a class="dropdown-item" href="#" @click="currency='BTC'">{{$t('OrderCurrency.BTC')}}</a>
                            </div>
                          </div>
                        </div>
                        <input id="amountOfCurrency" class="form-control" type="number" v-model="number" step="0.001" @change="changeNum" :readonly="step===3">
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4 ">
                      <label for="referenceExchangeRate" class="navbar-brand">{{$t('OrderCurrency.referenceExchangeRate')}}</label>
                      <a tabindex="0" class="btn btn-sm border-0" role="button" data-toggle="popover" data-trigger="focus" :title="$t('OrderCurrency.referenceExchangeRate')" :data-content="$t('OrderCurrency.referenceExchangeRateTips')"><img src="../../../static/img/info.svg"></a>
                    </div>
                    <div class="form-inline col-12 col-lg-8 p-0">
                      <div class="input-group col-12 ">
                        <input type="text" id="referenceExchangeRate" class="form-control" :value="rate" aria-label="Recipient's username" aria-describedby="basic-addon2" readonly>
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon2">{{$t('orderlist.USD')}}/{{currency}}</span>
                        </div>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label for="budgetEstimate" class="navbar-brand">{{$t('OrderCurrency.budgetEstimate')}}</label>
                      <a tabindex="0" class="btn btn-sm border-0" role="button" data-toggle="popover" data-trigger="focus" :title="$t('OrderCurrency.budgetEstimate')" :data-content="$t('OrderCurrency.budgetEstimateTips')"><img src="../../../static/img/info.svg"></a>
                    </div>
                    <div class="form-inline col-12 col-lg-8 p-0">
                      <div class="input-group col-12 ">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon2">{{$t('orderlist.USD')}}</span>
                        </div>
                        <input id="budgetEstimate" type="text" class="form-control" :value="(rate*number).toFixed(2)" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                  <nav class="navbar col-12">
                    <div class="col-12 col-lg-4">
                      <label for="serviceCharge" class="navbar-brand">{{$t('OrderCurrency.serviceCharge')}}</label>
                      <a tabindex="0" class="btn btn-sm border-0" role="button" data-toggle="popover" data-trigger="focus" :title="$t('OrderCurrency.serviceCharge')" :data-content="$t('OrderCurrency.serviceChargeTips')"><img src="../../../static/img/info.svg"></a>
                    </div>
                    <div class="form-inline col-12 col-lg-8 p-0">
                      <div class="input-group col-12">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon2">{{$t('orderlist.USD')}}</span>
                        </div>
                        <input id="serviceCharge" type="text" class="form-control" :value="getServiceCharge" aria-describedby="basic-addon2" readonly>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
            <div v-if="step===4">
              <div class="p-0 card mt-4 pt-3 pb-3">
                <div class="p-5 text-center">
                  <p class="lead">{{$t('ApplicationCompleted.Applicationcompleted')}}</p>
                  <hr class="my-4 display-4">
                  <p>{{$t('ApplicationCompleted.pointOut')}}</p>
                  <router-link to="/user/order" class="btn btn-lg btn-primary">{{$t('ApplicationCompleted.ReturnButton')}}</router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="row no-gutters mt-4 col-12 p-0">
            <div class="col-6">
              <button class="btn btn-outline-secondary mr-3 col-5 col-md-4 col-lg-2" @click="clickBack" v-if="step<=3">{{$t('OrderTerms.BackButton')}}</button>
            </div>
            <div class="col-6 text-right p-0">
              <button class="btn btn-primary col-5 col-md-4 col-lg-2" :disabled="!confirmed||(step===2&&number==0)" @click="step++" v-if="step<3&&(rate*number).toFixed(2)<1000000">{{$t('OrderTerms.NextButton')}}</button>
              <a href="#" class="btn btn-primary col-5 col-md-4 col-lg-2" data-toggle="modal" data-target="#messageModal" v-if="(rate*number).toFixed(2)>=1000000">{{$t('OrderTerms.NextButton')}}</a>
              <a href="#" class="btn btn-success col-5 col-md-4 col-lg-2" data-toggle="modal" data-target="#authenticatorModal" v-if="step===3">{{$t('OrderTerms.CreateButton')}}</a>
            </div>
          </div>
        </div>
      </div>
    </main>
    <copyright></copyright>
    <form label-width="0px" class="demo-ruleForm needs-validation" novalidate>
      <div class="modal fade" id="authenticatorModal" tabindex="-1" role="dialog" aria-labelledby="authenticatorModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="authenticatorModalLabel">
                {{$t('TwiceVerification.twiceVerification')}}
              </h4>
            </div>
            <div class="modal-body pt-5 pb-5">
              <div class="form-group">
                <small>{{$t('TwiceVerification.verificationCodeExplainOrder')}}</small><br><br>
                <label for="verificationCodeStep2">
                  <h5>{{$t('TwiceVerification.verificationCode')}}</h5>
                </label>
                <input class="form-control form-control-lg mt-2" v-model="verificationCode" id="verificationCodeStep2" required />
                <div class="invalid-feedback">
                  {{$t('TwiceVerification.verificationCodeRequired')}}
                </div>
              </div>
            </div>
            <div class="modal-footer pt-5 pb-3">
              <div class="col-6">
                <button type="button" class="btn btn-lg btn-outline-secondary" data-dismiss="modal">{{$t('modal.modalCancel')}}
                </button>
              </div>
              <div class="col-6 text-right">
                <button class="btn btn-lg btn-primary" type="submit" @click="create">{{$t('TwiceVerification.modalSubmit')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="modal fade" id="messageModal" tabindex="-1" role="dialog" aria-labelledby="messageModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="messageModalLabel">
              {{$t('orderListPopup.Messgae')}}
            </h4>
          </div>
          <div class="modal-body pt-5 pb-5">
            <label>
              <h5>{{$t('OrderCurrency.traded')}}</h5>
            </label>
          </div>
          <div class="modal-footer pt-5 pb-3">
            <div class="col-6 text-right">
              <button class="btn btn-lg btn-primary" data-dismiss="modal">{{$t('modal.modalOk')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style src="../../../static/css/dashboard.css" />

<script type="text/javascript">
import navbar from './navbar'
import copyright from './copyright'
import { NmsClient, RestCfg } from '../../scripts/AllExport'
let orderCreateType = 'order-create'
export default {
  components: { navbar, copyright },
  data: function () {
    return {
      step: 1,
      confirmed: false,
      steps: [
        'step1',
        'step2',
        'step3',
        'step4'

      ],
      currency: 'BTC',
      rate: '',
      serviceCharge: '',
      number: 0,
      verificationCode: ''
    }
  },
  mounted() {
    $('#authenticatorModal').on('hidden.bs.modal', (event) => {
      this.verificationCode = ''
      if ($('.needs-validation')[0] !== undefined) {
        $('.needs-validation')[0].classList.remove('was-validated')
      }
    })
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
    $(function () { $("[data-toggle='popover']").popover() })
    $('.popover-dismiss').popover({
      trigger: 'focus'
    })
    this.init()
  },
  methods: {
    clickBack() {
      if (this.step === 1) {
        this.$router.push({ path: '/user/order' })
      } else {
        this.step--
      }
    },
    changeNum() {
      if (this.number === null || this.number === '' || parseFloat(this.number) === 0) { this.number = 0 } else {
        this.number = parseFloat(this.number).toFixed(3)
        if (this.number < 0.010) this.number = 0.010.toFixed(3)
      }
    },
    create() {
      let form = $('.needs-validation')[0]

      form.onsubmit = (event) => {
        event.preventDefault()
        if (form.checkValidity()) {
          NmsClient.send(
            RestCfg.POST,
            {
              'reqType': orderCreateType,
              'userOrder': {
                'payment_coin_type': this.currency,
                'payment_coin_amount': this.number,
                'exchange_estimated_rate': this.rate,
                'exchange_estimated_amount': (this.rate * this.number).toFixed(2),
                'exchange_estimated_service_charge': this.getServiceCharge
              },
              verificationCode: this.verificationCode
            },
            (response) => {
              this.step++
              $('#authenticatorModal').modal('hide')
            },
            null
          )
        }
        form.classList.add('was-validated')
      }
    },
    init() {
      NmsClient.send(
        RestCfg.POST,
        {
          'reqType': 'order-rate-query'
        },
        (response) => {
          this.rate = response.resultInfo.exchange_rate
          this.serviceCharge = response.resultInfo.service_fee
        },
        null
      )
    }
  },
  computed: {
    getServiceCharge() {
      if ((this.rate * this.number * this.serviceCharge).toFixed(2) === (this.rate * this.number).toFixed(2)) {
        return (this.rate * this.number).toFixed(2)
      }
      return (this.rate * this.number * this.serviceCharge).toFixed(2) > 0 ? (this.rate * this.number * this.serviceCharge).toFixed(2) : 0.01
    }
  },
  watch: {
    step (newStep, oldStep) {
      $(function () { $("[data-toggle='popover']").popover() })
    },
    number(newNum, oldNum) {
      if (parseFloat(this.number).toFixed(3) >= 9999.999) this.number = 9999.999.toFixed(3)
    }
  }

}
</script>
<style scoped>
.navbar {
  font-weight: normal;
}
.navbar-brand button{
  background-color: white;
}
.navbar-brand {
  font-size: 1.25rem;
}
.container{
  min-height:calc(100vh - 256px)
}
.nav-tabs.wizard li>* {
  position: relative;
  padding: 0.7em 0em 0.8em 1.5em;
  color: #999999;
  background-color: #dedede;
  border-color: #dedede;
  height: 43px;
}
@media(min-width:0px) {
  .nav-tabs.wizard li {
    position: relative;
    padding: 0;
    margin: 1px 4px 1px 0;
    width: 22.8%;
    float: left;
    text-align: center;
  }
}
.privacyPolicy-scroll-bar{
    overflow: auto;
    height: 420px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/order-create.vue